export enum TipoVehiculo {
    Aeronave = 0,
    Automotor = 1,
    Indistinto = 2
}